
































import { Vue, Component, Prop } from "vue-property-decorator";
import HasAppliedForMoreInformation from "./HasAppliedForMoreInformation.vue";
import GrButton from "./GrButton.vue";
import { notificationsStore, publicDataStore } from "~/store";

@Component({
  components: {
    HasAppliedForMoreInformation,
    GrButton,
  },
})
export default class ApplyForAccountEmail extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly resultCentered!: boolean;

  @Prop({ type: String, default: null })
  readonly linkSourceProp!: string;

  @Prop({ type: String, default: null })
  readonly btnText!: string;

  get appliedEmail() {
    return publicDataStore.appliedData?.email ?? null;
  }

  get btnTextComputed() {
    return this.btnText ?? this.$t("Jag vill ha mer info");
  }

  email: string | null = null;

  loadingSend = false;

  async handleApplyForMoreInformation() {
    if (!this.email) {
      return;
    }
    this.loadingSend = true;
    try {
      await publicDataStore.applyForCompanyAccount({
        companyInterestObject: {
          isDone: true,
          companyName: "",
          contactFirstName: "",
          contactLastName: "",
          email: this.email!,
          phone: null,
          numberOfExpectedRecritments: "0",
          linkSource: this.linkSource,
        },
      });
      this.pushToGtm();
    } catch (error) {
      notificationsStore.setErrorMessage({ error });
    } finally {
      this.loadingSend = false;
    }
  }

  pushToGtm() {
    const gtmlEvent = {
      eventCategory: "Company form",
      eventAction: "Submitted",
      event: "GAEvent",
    };

    const dataLayer = ((window as any).dataLayer as any[]) || [];

    dataLayer.push(gtmlEvent);
  }

  get linkSource(): string | null {
    if (this.linkSourceProp) {
      return this.linkSourceProp;
    }

    const result = this.$route.query.linkSource;

    if (!result) {
      return null;
    }

    if (typeof result === "string") {
      return result;
    }

    return result[0] ?? null;
  }
}
